import { get } from 'svelte/store'
import { fetchUtils } from '$utils/fetchUtils'
import type { DirrtyScriptErrorData } from '#lib/mmpv/types/substitutes.js'
import { mmpvState } from '#lib/mmpv/mmpv.state.svelte.js'
import { addNotification } from '#lib/stores.js'
import { NotificationType } from '$types/notification'
import { t } from '$i18n/i18n'

export async function checkScripts() {
	await fetchUtils
		.get('/api/materialData/substitutes/checkScripts')
		.then((data: DirrtyScriptErrorData[]) => {
			mmpvState.scriptErrors = [...(data ?? [])]
		})
		.catch(fetchUtils.catchErrorAndShowNotification())
}

type SubstituteScript = {
	substituteTypePublicId: string
	refMatPublicId: string | undefined
	canMatPublicId: string | undefined
	dirrtyScript: string
}

export async function saveScript(script: SubstituteScript): Promise<boolean> {
	let success = false
	await fetchUtils
		.post('/api/materialData/substitutes/mapping/save/new', script)
		.then(() => {
			addNotification({
				// get(t) resolves at call time (inside the .then), after translations have loaded
				message: get(t)('UI.mmpv.modal.substitute.script.saved.notification'),
				type: NotificationType.SUCCESS,
				target: 'modal'
			})
			success = true
		})
		.catch(fetchUtils.catchErrorAndShowNotification('modal'))
	return success
}
